import React from 'react';
import { type CarouselConsumerProps } from '../types';
import { CarouselConsumer } from '..';

export const Control = ({ children }: CarouselConsumerProps) => (
	<CarouselConsumer>{children}</CarouselConsumer>
);
